import { nextTick } from "vue";
import { projectsService } from "@/shared/projects/projects.service";
import { cloneDeep } from "@/shared/utils/helpers.js";
import { prepareWall } from "@/shared/projects/prepareData.js";
import { loveSnapshotService } from "@/apps/love/store/love-snapshot.service";

export default {
    namespaced: true,
    actions: {
        async loadProject({ rootState, commit }, uuid) {
            rootState.waiting = true;
            try {
                const { project, snapshot } = await projectsService.getOneWithSnapshot({
                    tool: "love",
                    uuid,
                });
                const wall = prepareWall(project);

                commit(
                    "love/setProject",
                    { testimonials: wall.testimonials, wall, snapshot },
                    { root: true }
                );
                rootState.waiting = false;
            } catch {
                /* eslint-disable-next-line no-empty */
            }
        },
        async saveSnapshot({ rootState, dispatch }) {
            rootState.waiting = true;
            const loveState = rootState.love;
            try {
                await loveSnapshotService.updateSnapshotAfterSave(loveState.wall.uuid, {
                    stateSlice: loveState,
                    actionToTakeIfNotRequired: () => dispatch("saveProject"),
                });
                rootState.waiting = false;
            } catch {
                /* eslint-disable-next-line no-empty */
            }
        },
        async saveProject({ rootState, commit }) {
            await nextTick();

            rootState.waiting = true;

            const loveModule = rootState.love;

            const wall = cloneDeep(loveModule.wall);
            wall.testimonials = cloneDeep(loveModule.testimonials);
            wall.testimonials.forEach((testimonial) => {
                testimonial.images = JSON.stringify(testimonial.images);
                testimonial.gifs = JSON.stringify(testimonial.gifs);
            });

            try {
                const project = await projectsService.update({
                    tool: "love",
                    uuid: loveModule.wall.uuid,
                    data: wall,
                });

                loveModule.hasSnapshot = false;

                const updatedWall = prepareWall(project);

                commit("showNotify", "autoSave", { root: true });
                commit(
                    "love/setProject",
                    {
                        testimonials: updatedWall.testimonials,
                        wall: updatedWall,
                        snapshot: {},
                    },
                    { root: true }
                );
                rootState.waiting = false;
                return true;
            } catch {
                return false;
            }
        },
    },
};
